import "./index.css";
import { ClosedAdminTabs } from "./components/Tabs/ClosedAdminTabs";
import { OpenAdminTabs } from "./components/Tabs/OpenAdminTabs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import salesIcon from "../../assets/admin-dash/tabs-icons/sales-icon-admin.svg";
import mgmtIcon from "../../assets/admin-dash/tabs-icons/mgmt-icon-admin.svg";
import boardIcon from "../../assets/admin-dash/tabs-icons/board-icon-admin.svg";
import hrIcon from "../../assets/admin-dash/tabs-icons/hr-icon-admin.svg";
import marketingIcon from "../../assets/admin-dash/tabs-icons/marketing-icon-admin.svg";
import designIcon from "../../assets/admin-dash/tabs-icons/design-icon-admin.svg";
import productionIcon from "../../assets/admin-dash/tabs-icons/production-icon-admin.svg";
import logisticsIcon from "../../assets/admin-dash/tabs-icons/logistics-icon-admin.svg";
import commsIcon from "../../assets/admin-dash/tabs-icons/comms-icon-admin.svg";
import timePlanningIcon from "../../assets/admin-dash/tabs-icons/time-planning-icon-admin.svg";
import businessPartnerIcon from "../../assets/admin-dash/tabs-icons/business-partner-icon-admin.svg";

const AdminDash = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState("");
  const handleClick = (name) => {
    setOpen(name);
  };
  const tabs = [
    { id: 1, name: t("SALES"), nickname: t("SALES"), icon: salesIcon },
    { id: 2, name: t("MANAGEMENT"), nickname: t("MGMT"), icon: mgmtIcon },
    { id: 3, name: t("BOARD"), nickname: t("BOARD"), icon: boardIcon },
    { id: 4, name: t("HR"), nickname: t("HR"), icon: hrIcon },
    {
      id: 5,
      name: t("MARKETING"),
      nickname: t("MARKETING"),
      icon: marketingIcon,
    },
    { id: 6, name: t("DESIGN"), nickname: t("DESIGN"), icon: designIcon },
    {
      id: 7,
      name: t("PRODUCTION"),
      nickname: t("PRODUCTION"),
      icon: productionIcon,
    },
    {
      id: 8,
      name: t("LOGISTICS"),
      nickname: t("LOGISTICS"),
      icon: logisticsIcon,
    },
    { id: 9, name: t("COMMUNICATIONS"), nickname: t("COMMS"), icon: commsIcon },
    {
      id: 10,
      name: t("TIME_PLANNING"),
      nickname: t("TIME_PLANNING"),
      icon: timePlanningIcon,
    },
    {
      id: 11,
      name: t("BUSINESS_PARTNER"),
      nickname: t("BUSINESS_PARTNER"),
      icon: businessPartnerIcon,
    },
  ];
  return (
    <div className="admin-dash-container">
      <div className="admin-tabs-container ">
        {tabs.map((item) => {
          return open === item.nickname ? (
            <OpenAdminTabs
              name={item.nickname}
              key={item.id}
              onClick={() => handleClick("")}
              icon={item.icon}
            />
          ) : (
            <ClosedAdminTabs
              name={item.nickname}
              key={item.id}
              onClick={() => handleClick(item.nickname)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AdminDash;
